import { Info } from "lucide-react";
import { Reveal } from "./Reveal";

const TOPICS = [
  ["Market fundamentals", "How Dubai’s real estate market works and who the key participants are."],
  ["Off-plan vs. ready", "The differences in timing, risk, and flexibility between the two."],
  ["Developers & projects", "How to compare developers, track records, and project specifications."],
  ["Location & price per sq. ft.", "Reading areas and comparing value using price-per-square-foot analysis."],
  ["Payment plans", "Cash, installment, and post-handover plans, and what each means for you."],
  ["Fees & additional costs", "Purchase fees and the other costs to budget for beyond the property price."],
  ["Rental income & appreciation", "How rental income and potential capital appreciation are estimated."],
  ["Risks & due diligence", "The investment risks to understand and the checks to make before deciding."],
];

export function Learn() {
  return (
    <section id="learn" className="py-24 sm:py-32 px-6 sm:px-10 bg-white" data-testid="learn-section">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-4">
            <p className="eyebrow">What you’ll learn</p>
            <h2 className="font-display mt-4 text-3xl sm:text-4xl font-bold text-[#0B1F3A] leading-tight">
              Eight topics. One clear picture.
            </h2>
            <p className="mt-5 text-[#697386] leading-relaxed">
              Each briefing is shaped around your goals, covering the essentials you need to evaluate an opportunity calmly.
            </p>
          </Reveal>
          <div className="lg:col-span-8 grid sm:grid-cols-2 border-t border-[rgba(20,35,55,0.10)]">
            {TOPICS.map(([title, text], i) => (
              <Reveal key={title} delay={(i % 2) * 0.06}>
                <div className={`py-7 border-b border-[rgba(20,35,55,0.10)] ${i % 2 === 0 ? "sm:pr-10" : "sm:pl-10 sm:border-l"}`} data-testid={`learn-topic-${i + 1}`}>
                  <span className="text-xs font-semibold tracking-[0.2em] text-[#C7A76C]">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display mt-3 text-lg font-semibold text-[#172033]">{title}</h3>
                  <p className="mt-2 text-[15px] text-[#697386] leading-relaxed">{text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal>
          <div className="mt-14 lg:ml-[33.333%] flex gap-4 rounded-2xl bg-[#F5F7FA] border border-[rgba(20,35,55,0.08)] p-5 sm:p-6" data-testid="learn-usd-note">
            <Info size={18} className="text-[#C7A76C] shrink-0 mt-0.5" />
            <p className="text-sm text-[#697386] leading-relaxed">
              All figures discussed are shown in US dollars (USD) as reference conversions. Converted figures are estimates; the actual payment currency, exchange rates, and transaction costs may differ.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
